/**
 * فریم‌های پرده‌برداری هیرو: نشانی‌ها و اعلانِ فریم اول در <head>.
 *
 * جدا از components/hero.tsx عمداً: صفحه‌ی اصلی این‌ها را در `head` خودش لازم دارد، و اگر از
 * خودِ hero.tsx بیایند، باندلر کل آن پرونده و وابستگی‌هایش (GSAP) را به چانکِ ورودی می‌کشد —
 * اندازه‌گیری: ۶۵۶ کیلوبایت به ۷۹۹ کیلوبایت، و چانک جداگانه‌ی مسیرها از بین می‌رفت.
 */

/**
 * فریم‌های public/frames: پرده‌برداری از خودرو (ffmpeg از video.mp4، نوارهای سیاه بریده). lg: ۱۶۰۰×۹۰۰ و
 * همه‌ی ۱۹۲ فریم برای دسکتاپ و تبلت؛ sm: ۱۲۰۰×۶۷۵ و یک در میان (۹۶) برای گوشی تا حجم و حافظه نصف شود.
 */
export const SETS = { lg: 192, sm: 96 } as const;
export type FrameSet = keyof typeof SETS;

export const frameUrl = (set: FrameSet, index: number) =>
  `/frames/${set}/${String(index + 1).padStart(4, "0")}.webp`;

/** گوشی (ضلع کوتاه‌تر زیر ۶۰۰ پیکسل، در هر جهت) sm می‌گیرد */
export const pickSet = (): FrameSet => (Math.min(innerWidth, innerHeight) < 600 ? "sm" : "lg");

/**
 * شرطِ «گوشی» (همان pickSet) به زبان media، به اضافه‌ی «کاهش حرکت» که آن‌جا فقط فریم آخر
 * کشیده می‌شود و فریم اول به کار نمی‌آید
 */
const SM_MEDIA =
  "(prefers-reduced-motion: no-preference) and ((max-width: 599px) or (max-height: 599px))";

/**
 * <link rel=preload> فریم اولِ مجموعه‌ی گوشی، برای head صفحه‌ی اصلی. همان فریم، پوسترِ
 * `.hero-stage` در CSS است و بزرگ‌ترین نقاشیِ صفحه (LCP) را می‌سازد؛ بی این خط مرورگر تازه پس از
 * خواندن CSS به آن می‌رسد (ایراد `lcp-discovery-insight` لایت‌هاوس).
 *
 * فقط گوشی، و فقط همین یک فریم. اندازه‌گیری: اعلام شش فریم اول LCP موبایل را بدتر می‌کرد
 * (پهنای باند را از CSS و JS می‌گرفت)، و اعلام فریم lg روی دسکتاپ — که LCPاش از پیش ۱٫۸ ثانیه
 * است — نمره را دو واحد پایین می‌آورد.
 */
export const heroFramePreloads = [
  {
    rel: "preload",
    as: "image",
    type: "image/webp",
    href: frameUrl("sm", 0),
    media: SM_MEDIA,
    fetchPriority: "high",
  },
];
